/* Установщик «Открытка»: объект в window на том месте порядка скриптов, где стоял assets/bot-mcard.js.
   В серверном режиме движок шаблона получает сервер экрана (mcard-server.ts) и экран mcard встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createMcard } from './engine';
import { createMcardServer, registerMcardEngine } from './mcard-server';

export function installMcard() {
  const server = isServerMode();
  createMcard(server ? createMcardServer : null);
  if (server) registerMcardEngine();
}
